module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rNXUqG/tc-custom/9781611522785.jpg?1721057612054",
      "alt": "This image is the cover for the book David and Andrew Book 3: The Next Generation, David and Andrew"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("David and Andrew Book 3: The Next Generation, David and Andrew\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Brad Sturgis, adopted son of Andy Barnes and David Bennett, is all grown up and ready to face life with his boyfriend, Hank Reynolds. However, he soon discovers life away from the Bennett-Barnes household proves much trickier than it seemed when he was growing up."), _c('br'), _c('br'), _vm._v("Brad finds many things in Hank’s work as a horse trainer competing for the man’s attention and affection. The time-consuming nature of the equine show world and the constant demands of the clients Hank coaches -- their interest in him sometimes goes beyond that of trainer/rider -- test the strength of the bond between the two men."), _c('br'), _c('br'), _vm._v("Will Brad learn to face such challenges with courage and good humor as his adoptive parents did before him? Will the next generation prove to be as tough and as tender, as solid and as steadfast as the one before?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Terry O'Reilly\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    JMS Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0